import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import * as React from 'react';
import classNames from 'classnames';
import ConfigContext from '../config-provider/ConfigContext';
import { getCompProps } from '../_utils';
import Radio from './radio';
import { RadioGroupContextProvider } from './context';
var RadioGroup = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _React$useContext = React.useContext(ConfigContext),
    getPrefixCls = _React$useContext.getPrefixCls,
    prefixCls = _React$useContext.prefixCls,
    userDefaultProps = _React$useContext.compDefaultProps;
  var initValue = typeof props.value === 'undefined' ? props.defaultValue : props.value;
  var _React$useState = React.useState(initValue),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    value = _React$useState2[0],
    setValue = _React$useState2[1];
  // 从props更新value值
  React.useEffect(function () {
    if (typeof props.value !== 'undefined') {
      setValue(props.value);
    }
  }, [props.value]);
  var onRadioChange = function onRadioChange(ev, checkedValue) {
    var lastValue = value;
    if (!('value' in props)) {
      setValue(checkedValue);
    }
    var onChange = props.onChange;
    if (onChange && checkedValue !== lastValue) {
      onChange(ev, checkedValue);
    }
  };
  var renderGroup = function renderGroup() {
    var _getCompProps = getCompProps('RadioGroup', userDefaultProps, props),
      id = _getCompProps.id,
      style = _getCompProps.style,
      options = _getCompProps.options,
      disabled = _getCompProps.disabled,
      children = _getCompProps.children,
      className = _getCompProps.className,
      optionType = _getCompProps.optionType,
      customPrefixcls = _getCompProps.prefixCls; // 属性需要合并一遍用户定义的默认属性
    var groupPrefixCls = getPrefixCls === null || getPrefixCls === void 0 ? void 0 : getPrefixCls(prefixCls, "radio-group", customPrefixcls); // 单选组样式前缀
    var radioPrefixCls = getPrefixCls === null || getPrefixCls === void 0 ? void 0 : getPrefixCls(prefixCls, "radio", customPrefixcls); // 单选样式前缀
    var childrenToRender = children;
    // 如果存在 options, 优先使用
    if (options && options.length > 0) {
      var _context;
      var optionsPrefixCls = optionType === undefined ? radioPrefixCls : _concatInstanceProperty(_context = "".concat(radioPrefixCls, "-")).call(_context, optionType);
      childrenToRender = _mapInstanceProperty(options).call(options, function (option) {
        if (typeof option === 'string') {
          // 此处类型自动推导为 string
          return /*#__PURE__*/React.createElement(Radio, {
            key: option,
            prefixCls: optionsPrefixCls,
            disabled: disabled,
            value: option,
            checked: value === option
          }, option);
        }
        // 此处类型自动推导为 { label: string value: string }
        return /*#__PURE__*/React.createElement(Radio, {
          key: "radio-group-value-options-".concat(option.value),
          prefixCls: optionsPrefixCls,
          disabled: option.disabled || disabled,
          value: option.value,
          checked: value === option.value,
          style: option.style
        }, option.label);
      });
    }
    return /*#__PURE__*/React.createElement("div", {
      className: classNames(groupPrefixCls, className),
      style: style,
      id: id,
      ref: ref
    }, childrenToRender);
  };
  return /*#__PURE__*/React.createElement(RadioGroupContextProvider, {
    value: {
      value: value,
      name: props.name,
      onChange: onRadioChange,
      disabled: props.disabled
    }
  }, renderGroup());
});
export default /*#__PURE__*/React.memo(RadioGroup);